import { css } from 'lit';

export default css`
  /* Typography */

  --font-family-inter: "Inter", Inter, Arial, sans-serif;
  --font-family-roboto: "Roboto", Inter, Arial, sans-serif;
  --font-family-telex: "Telex", Inter, Arial, sans-serif;
  --font-family-jersey: "Jersey 10", Inter, Arial, sans-serif;
  --font-family-stix: "STIX Two Text", Inter, Arial, sans-serif;
  --font-family-domine: "Domine", Inter, Arial, sans-serif;

  --font-app-author: var(--font-family-domine);
  --font-app-dam: var(--font-family-jersey);
  --font-app-publisher: var(--font-family-roboto);
  --font-app-keyword: var(--font-family-telex);
  --font-app-update-asset: var(--font-family-stix);

  --font-family-base: var(--font-family-inter);
  --base-font-size: 16px;

  --font-weight-light: 300;
  --font-weight-regular: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;

  --line-height-base: 1.5;
  --line-height-tight: 1.2;

  --font-size-h1: 3rem;         
  --line-height-h1: 3.625rem;   

  --font-size-h2: 2.5rem;       
  --line-height-h2: 3rem;       

  --font-size-h3: 2rem;         
  --line-height-h3: 2.375rem;   

  --font-size-h4: 1.75rem;      
  --line-height-h4: 2.125rem;   

  --font-size-h5: 1.5rem;       
  --line-height-h5: 1.75rem;    

  --font-size-s1: 1.125rem;     
  --line-height-s1: 1.75rem;    

  --font-size-s2: 1rem;         
  --line-height-s2: 1.5rem;     

  --font-size-b1: 1rem;
  --line-height-b1: 1.5rem;
  --font-size-b2: 1rem;
  --line-height-b2: 1.5rem;

  --font-size-b3: 0.875rem;     
  --line-height-b3: 1.25rem;    
  --font-size-b4: 0.875rem;
  --line-height-b4: 1.25rem;

  --font-size-c1: 0.75rem;      
  --line-height-c1: 1rem;       
  --font-size-c2: 0.75rem;
  --line-height-c2: 1rem;
  --font-size-c3: 0.625rem;     
  --line-height-c3: 0.875rem;   

  --font-size-label: 0.75rem;
  --line-height-label: 1rem;

  --font-size-button-giant: 1.125rem;     
  --line-height-button-giant: 1.5rem;     

  --font-size-button-large: 1rem;         
  --line-height-button-large: 1.25rem;    

  --font-size-button-medium: 0.875rem;    
  --line-height-button-medium: 1rem;      

  --font-size-button-small: 0.75rem;      
  --line-height-button-small: 1rem;       

  --font-size-button-tiny: 0.625rem;      
  --line-height-button-tiny: 0.75rem;
`;
